import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const LanguageOutlined = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M17.12 5 14 4.98C14 3.89 13.11 3 12.02 3H4.98C3.89 3 3 3.89 3 4.98v7.04C3 13.11 3.89 14 4.98 14h7.04c1.09 0 1.98-.89 1.98-1.98V9c1.5-.69 2.6-1.91 3.44-3.46a.369.369 0 0 0-.32-.54Zm-3.75 2.64c-.53.24-.87.78-.87 1.36v3.02c0 .26-.22.48-.48.48H4.98c-.26 0-.48-.22-.48-.48V4.98c0-.26.22-.48.48-.48h7.04c.26 0 .48.22.48.48 0 .83.67 1.5 1.49 1.5h.96c-.48.51-1 .89-1.58 1.16Z" />
      <Path d="m9.06 5.98.16.75h.72v1.02c-.17.06-.38.1-.58.1-.2 0-.41-.03-.58-.1.09-.17.15-.38.15-.59 0-.68-.56-1.22-1.26-1.22-.4 0-.88.19-1.26.56l.5.76c.27-.23.64-.44.91-.44.22 0 .32.12.32.27 0 .34-.64.57-1.1.69l.4.88a2 2 0 0 0 .71-.27c.18.13.27.31.27.48 0 .28-.24.53-.6.53-.45 0-.87-.39-1.15-1.11l-.65.35c.36 1.02 1.09 1.72 1.98 1.72.79 0 1.3-.55 1.3-1.15 0-.23-.08-.47-.22-.68.19.14.43.22.67.22.06 0 .14 0 .21-.02v1.59l1 .13V6.74h.71l-.16-.75H9.08l-.02-.01ZM13.69 18c.1 0 .2-.03.28-.08.09-.05.15-.13.2-.24l.31-.67h2.16l.3.67c.05.11.12.19.2.24.08.05.18.08.28.08.15 0 .28-.05.4-.15.12-.1.18-.23.18-.37 0-.08-.02-.16-.06-.25l-1.76-3.61a.639.639 0 0 0-.26-.28.746.746 0 0 0-.75 0c-.11.06-.2.16-.26.28l-1.76 3.61c-.04.08-.06.17-.06.25 0 .15.06.27.18.37.12.1.26.15.41.15h.01Zm1.87-3.4.67 1.48H14.9l.67-1.48h-.01Z" />
      <Path d="M19.02 10h-4.29v1.5h4.29c.26 0 .48.22.48.48v7.04c0 .26-.22.48-.48.48h-7.04c-.26 0-.48-.22-.48-.48 0-.83-.67-1.5-1.49-1.5H8.68c.58-.81 1.11-.98 1.51-1.03A1.5 1.5 0 0 0 11.5 15v-.4H10v.4c-1.64.21-2.69 1.5-3.45 3.32-.14.32.09.68.44.68l3.01.02c0 1.09.89 1.98 1.98 1.98h7.04c1.09 0 1.98-.89 1.98-1.98v-7.04c0-1.09-.89-1.98-1.98-1.98Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default LanguageOutlined
